import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y, filter: "blur(6px)" }}
    whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ overline, title, text, dark = false, center = false }) => (
  <div className={`max-w-2xl ${center ? "mx-auto text-center" : ""}`}>
    {overline && (
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.28em] text-cob-gold">{overline}</p>
      </Reveal>
    )}
    <Reveal delay={0.08}>
      <h2
        className={`mt-4 font-serif text-3xl sm:text-4xl lg:text-[2.75rem] font-semibold tracking-tight leading-[1.12] ${
          dark ? "text-white" : "text-cob-dark"
        }`}
      >
        {title}
      </h2>
    </Reveal>
    {text && (
      <Reveal delay={0.16}>
        <p className={`mt-5 text-base sm:text-lg leading-relaxed ${dark ? "text-white/70" : "text-cob-muted"}`}>
          {text}
        </p>
      </Reveal>
    )}
  </div>
);
